'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportDataController = function () {
  function ReportDataController(loadingService, reportingService, $scope, $filter) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ReportDataController);
    this.loadingService = loadingService;
    this.reportingService = reportingService;
    this.$scope = $scope;
    this.$filter = $filter;

    this.$scope.$on('reports:runReport', this.runReport.bind(this));
    this.$scope.$on('reports:reset', this.reset.bind(this));
  }

  (0, _createClass3.default)(ReportDataController, [{
    key: 'reset',
    value: function reset() {
      this.reportData = [];
    }
  }, {
    key: 'runReport',
    value: function runReport(e, data) {
      var _this = this;

      if (!data.criteriaValidator()) {
        return;
      }

      this.loadingService.showLoading('reportData', 'Running Report ...');

      this.reportingService.runReport(data.action, data.criteriaParser()).then(function (response) {
        _this.reportHeaders = response.data.headers;

        if (data.selector) {
          _this.reportData = data.selector(response.data.data);
        } else {
          _this.reportData = response.data.data;
        }
        _this.onReportRun({ summary: response.data.summary, data: _this.reportData });
      }).finally(function () {
        _this.loadingService.hideLoading('reportData');
      });
    }
  }]);
  return ReportDataController;
}();

exports.default = ReportDataController;


// WEBPACK FOOTER //
// ./client/app/components/reports/reportData/reportData.controller.js